<template>
  <base-table
    title="Trials"
    item-title="Trial"
    route-name="vesselTrialDetails"
    get-url="/byvessel"
    :headers="headers"
    :url="url"
    :item="vesselTrial"
    :item-id="vesselTrial.vesselTrialId"
    :get-id="id"
    @set-item="setItem"
  >
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="vesselTrial.dueDate | formatDate"
          label="Due Date"
          prepend-icon="mdi-calendar"
          v-on="on"
          clearable
          :rules="[rules.required]"
          required
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="vesselTrial.dueDate"
        no-title
        @input="menu = false"
        :rules="[rules.required]"
        required
      ></v-date-picker>
    </v-menu>
    <v-select
      v-model="vesselTrial.assignedUserId"
      :items="users"
      item-text="name"
      item-value="userId"
      label="Assignee"
      :rules="[rules.required]"
      required
    ></v-select>
  </base-table>
</template>
<script>
import ApiService from '@/services/ApiService.js'
import ObjectType from '@/services/Objects.js'
import { trialStatusConstant } from '@/utils/constants.js'
import BaseTable from '@/components/tables/BaseTable.vue'
import Validation from '@/mixins/validation.js'

export default {
  name: 'VesselTrialTable',
  components: {
    BaseTable
  },
  mixins: [Validation],
  props: {
    id: String
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      vesselTrial: {
        dueDate: '',
        assignedUserId: '',
        vesselId: this.id,
        status: trialStatusConstant.Draft.value
      },
      url: ObjectType.VesselTrial,
      menu: false,
      users: []
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    setItem(item) {
      this.vesselTrial = Object.assign({}, item)
    },
    getUsers() {
      ApiService.get(ObjectType.User).then(response => {
        this.users = response.data
      })
    }
  }
}
</script>

<style scoped></style>
